export default {
    ACTIVITY_TYPE_DATA: {
        'S_XDGH': {
            activityEffectText: '消费者提交订单后自动发送短信给消费者，可发送商品使用说明、注意事项等场景，增强消费者对品牌的认知以及提高消费者黏性。',
            defaultOrderStatus: 1,
            orderTypeList: [0, 1, 2],
        },
        'S_DDCF': {
            activityEffectText: '对下单未 付款的消费者自动发送催付短信，可用于催促消费者付款等场景，有助于提升付款率。',
            defaultOrderStatus: 1,
            orderTypeList: [1],
        },
        'S_SJFH': {
            activityEffectText: '当商家发货后自动发送短信给消费者，可以告知店铺已发货等信息，加强消费者对店铺的依赖和认同感。',
            defaultOrderStatus: 3,
            orderTypeList: [0, 1, 2],
        },
        'S_TCTX': {
            activityEffectText: '当快件到达消费者所在城市后自动发送短信，告知消费者准备收货等内容，提升客户满意度。',
            defaultOrderStatus: 3,
            orderTypeList: [0, 1, 2],
        },
        'S_QSGH': {
            activityEffectText: '当消费者签收后自动发送短信，提醒消费者及时确认收货等内容，提升客户满意度。',
            defaultOrderStatus: 3,
            orderTypeList: [0, 1, 2],
        },
        'S_SHSQ': {
            activityEffectText: '对申请售后的消费者自动发送短信，降低退款率。',
            defaultOrderStatus: 6,
            orderTypeList: [0, 1, 2],
        },
        'S_JJSH': {
            activityEffectText: '在拒绝消费者售后申请后，自动发送短信说明拒绝原因等，降低售后纠纷率。',
            defaultOrderStatus: 6,
            orderTypeList: [0, 1, 2],
        },
        'S_WCTX': {
            activityEffectText: '消费者点击“确认收货”后自动发送短信，告知注意事项，使用说明等信息，提高客户满意度和店铺评分。',
            defaultOrderStatus: 5,
            orderTypeList: [0, 1, 2],
        },
        'S_PJTX': {
            activityEffectText: '快件显示正在派件时自动发送短信，提醒消费者注意取件等信息，提升客户满意度。',
            defaultOrderStatus: 3,
            orderTypeList: [0, 1, 2],
        },
        'S_YCFH': {
            activityEffectText: '在商家超时未发货时自动给消费者发送短信，可以告知延迟发货原因或表达歉意等内容，降低退款率。',
            defaultOrderStatus: 2,
            orderTypeList: [0, 1, 2],
        },
        'S_YSCF': {
            activityEffectText: '对预售订单没有付定金 / 尾款的消费者，自动发送催付短信，可有效提升店铺付款率。',
            defaultOrderStatus: 1,
            orderTypeList: [1],
        },
        'S_FKGH': {
            activityEffectText: '对已付款消费者自动发送短信，提示注意事项、预计发货时间等内容，提升客户满意度。',
            defaultOrderStatus: 2,
            orderTypeList: [0, 1, 2],
        },
        'S_WLFH': {
            activityEffectText: '物流揽收后自动发送短信给消费者，可以提示物流信息等内容，提升消费者购物体验和店铺物流评分。',
            defaultOrderStatus: 3,
            orderTypeList: [0, 1, 2],
        },
        'S_QJTX': {
            activityEffectText: '快件状态变为”待取件“后自动发送短信，提醒消费者及时取件等内容，提升客户满意度。',
            defaultOrderStatus: 3,
            orderTypeList: [0, 1, 2],
        },
        'S_DDCP': {
            activityEffectText: '对已确认收货但仍未评价的消费者自动发送短信，引导消费者进行评价，提升店铺评分。',
            defaultOrderStatus: 5,
            orderTypeList: [0, 1, 2],
        },
        'S_TYTK': {
            activityEffectText: '在商家同意售后后自动发送短信，可以提示消费者及时邮寄商品等内容。',
            defaultOrderStatus: 6,
            orderTypeList: [0, 1, 2],
        },
        'S_SHCG': {
            activityEffectText: '消费者售后成功后自动发送短信，表达遗憾欢迎下次选购等内容，提高消费者好感争取下次转化。',
            defaultOrderStatus: 6,
            orderTypeList: [0, 1, 2],
        },
        'S_ZLTX': {
            activityEffectText: '当快递投放至快递柜或驿站长时间未取自动发送短信，再次提醒消费者取件，增强消费者依赖。',
            defaultOrderStatus: 3,
            orderTypeList: [0, 1, 2],
        },
        'S_WLYC': {
            activityEffectText: '对物流异常的订单自动发送短信，及时提醒消费者查询处理等内容，提升客户满意度。',
            defaultOrderStatus: 3,
            orderTypeList: [0, 1, 2],
        },
        'S_QXDD': {
            activityEffectText: '对取消订单的消费者自动发送短信，利用优惠等策略挽回消费者，降低订单流失率。',
            defaultOrderStatus: 4,
            orderTypeList: [0, 1, 2],
        },
    },
    TRIGGER_EVENT_TEXT: {
        'S_XDGH': '消费者提交订单后立即发送短信',
        'S_SJFH': '商家发货后立即发送短信',
        'S_TCTX': '快件到达消费者所在城市后立即发送短信',
        'S_QSGH': '消费者签收后立即发送短信',
        'S_WCTX': '消费者点击“确认收货”后立即发送短信',
        'S_PJTX': '快件显示正在派件时立即发送短信',
        'S_WLFH': '物流揽收后立即发送短信',
        'S_QJTX': '快件状态变为”待取件“后立即发送短信',
        'S_ZLTX': '快件状态变为”滞留中“后立即发送短信',
        'S_WLYC': '物流显示异常时自动发送短信',
        'S_QXDD': '消费者取消订单后立即发送短信',
    },
    SELECT_TIME_DATA_SOURCE: [
        { label: '分钟', value: 'min' },
        { label: '小时', value: 'hours' },
    ],
    SELECT_TIME_DATA_SOURCE1: [
        { label: '天', value: 'day' },
        { label: '小时', value: 'hours' },
        { label: '月', value: 'month' },
    ],
    SELECT_TIME_DATA_SOURCE2: [
        { label: '分钟', value: 'min' },
        { label: '小时', value: 'hours' },
        { label: '天', value: 'day' },
    ],
    SELECT_ORDER_TYPE_DATA_SOURCE: [
        { label: '未发货-仅退款', value: 1 },
        { label: '已发货-仅退款', value: 2 },
        { label: '已发货-退货退款', value: 3 },
        { label: '已发货-换货', value: 4 },
    ],
    TRIGGER_EVENT_DEFAULT_VALUE: {
        'S_DDCF': {
            triggerType: 1,//1消费者提交订单xx后未付款 2距订单取消剩余xx未付款
            number: 15,
            unit: 'min',
        },
        'S_SHSQ': {//售后申请
            triggerType: [],//1未发货-仅退款 2已发货-仅退款 3已发货-退货退款 4已发货-换货
        },
        'S_JJSH': {//拒绝售后
            triggerType: [],//1未发货-仅退款 2已发货-仅退款 3已发货-退货退款 4已发货-换货
        },
        'S_TYTK': {//同意退款
            triggerType: [],//1未发货-仅退款 2已发货-仅退款 3已发货-退货退款 4已发货-换货
        },
        'S_SHCG': {//售后成功
            triggerType: [],//1未发货-仅退款 2已发货-仅退款 3已发货-退货退款 4已发货-换货
        },
        'S_YCFH': {//延迟发货
            triggerType: 1,//1商家超时未发货后立即发送短信 2消费者提交订单xx后仍未发货
            number: 15,
            unit: 'hours', //hours小时 day天 month月
        },
        'S_YSCF': {//预售催付
            triggerType: 1,//1尾款支付开始xx后仍未付款 2距离尾款支付结束时间仅剩余xx仍未付款
            number: 15,
            unit: 'min', //min分钟 hours小时
            paymentReminderType: 1,//1尾款催付，2定金催付
        },
        'S_FKGH': {//付款关怀
            number: 15,
            unit: 'min', // min 分钟 hours小时 day天
        },
        'S_DDCP': {//订单催评
            number: 15,
            unit: 'min', // min 分钟 hours小时 day天
        },
    },
    UNIT_MAX_NUM: {
        'min': 59,
        'hours': 24,
        'day': 30,
        'month': 12,
    },
    ORDER_STATUS_LIST: [
        { label: '待支付', value: 1, tips: '指消费者选择"在线支付”的支付方式下单，但并没有完成付款动作的全部订单(如用户未在限定时间内完成付款，订单将会被自动取消)。' },
        { label: '备货中', value: 2, tips: '商家需要发货的全部订单(包含在线支付订单和货到付款订单)。' },
        { label: '已发货', value: 3, tips: '指您(品牌方)已操作发货且上传了真实有效物流单号的全部订单。' },
        { label: '已完成', value: 5, tips: '指已经发货且消费者点击确认收货或超时未点击系统自动确认收货后的订单。' },
        { label: '已取消', value: 4, tips: '指在线支付--待支付时消费者主动取消或超时末付款自动取消的订单;货到付款--在待支付和备货中被消费者主动取消、在已发货后被拒收/退回的订单。' },
        { label: '售后中', value: 6, tips: '指消费者申请退款或退货处于售后中的全部订单。' }
    ],
    CARE_LIST: {
        'S_XDGH': '下单关怀',
        'S_DDCF': '订单催付',
        'S_SJFH': '商家发货',
        'S_TCTX': '同城提醒',
        'S_QSGH': '签收关怀',
        'S_SHSQ': '售后申请',
        'S_JJSH': '拒绝售后',
        'S_WCTX': '完成提醒',
        'S_PJTX': '派件提醒',
        'S_YCFH': '延迟发货',
        'S_YSCF': '预售催付',
        'S_FKGH': '付款关怀',
        'S_WLFH': '物流发货',
        'S_QJTX': '取件提醒',
        'S_DDCP': '订单催评',
        'S_TYTK': '同意退款',
        'S_SHCG': '售后成功',
        'S_ZLTX': '滞留提醒',
        'S_WLYC': '物流异常',
        'S_QXDD': '取消订单',
    },

}